// extracted by mini-css-extract-plugin
export default {"png_line":"footerDetails_png_line__KaBIb"};